/** Name the FE gives the aggregated document merged from every uploaded doc. */
export const AGGREGATED_DOCUMENT_NAME = 'all_documents.pdf';
